import { PandaboardApiInstance } from "../../../helpers/api";

export const fetchGetSellResponsible = async (ozonerId: string, financialFormId: string) =>
  PandaboardApiInstance
    .post("sales/assign-seller", { ozonerId, financialFormId }, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
